import type { TransactionRule } from '@carboncopyco/types';
import { Modal, type ModalProps, notify } from '@carboncopyco/ui';
import type { UseEditTransactionRule } from './EditTransactionRuleContext';
import { EditTransactionRuleModalContent } from './EditTransactionRuleModalContent';

export interface EditTransactionRuleModalProps
  extends Pick<ModalProps, 'open' | 'onClose'>,
    Pick<
      UseEditTransactionRule,
      'onLearnMoreClick' | 'transactionModifications'
    > {
  transactionRule: TransactionRule;
  onSubmit: (
    transactionRule: TransactionRule,
    refresh?: boolean
  ) => Promise<unknown>;
}

export const EditTransactionRuleModal = ({
  onLearnMoreClick,
  transactionRule,
  transactionModifications,
  open,
  onClose,
  onSubmit,
}: EditTransactionRuleModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      noPadding
      floatingCloseButton
      closeOnlyFromCloseIcon
    >
      <div className="w-ds-lg-modal">
        <EditTransactionRuleModalContent
          onLearnMoreClick={onLearnMoreClick}
          transactionRule={transactionRule}
          transactionModifications={transactionModifications}
          cancelEdit={onClose}
          submitEdit={async (editedRule, refresh) => {
            try {
              await onSubmit(
                {
                  ...transactionRule,
                  ...editedRule,
                },
                refresh
              );
            } catch (error) {
              console.error(error);
              notify.error('Failed to edit data rule');
            }
          }}
        />
      </div>
    </Modal>
  );
};
